module.exports = __webpack_public_path__ + "img/sign-bg.58d8e5f7.png";